module.exports = __webpack_public_path__ + "static/media/help-rule-4.6d9f3b68.gif";